import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';

const NotificationThemeTag = ({ name, color }) => (
  <S.NotificationThemeTag color={color}>{name}</S.NotificationThemeTag>
);

NotificationThemeTag.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
};

export { NotificationThemeTag };
